<template>
  <AdminMachineList :pk="'CML-'" :lockedFilters="{ CustomerId: $route.params.customerId }" hideOwnershipFilters
    allowSelectAll groupByUnit>
  </AdminMachineList>
</template>


<script>
import AdminMachineList from "@/views/admin/machines/AdminMachineList.vue";

export default {
  name: "CustomerMachines",
  props: {},
  components: {
    AdminMachineList,
  },

  data() {
    return {};
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>